import LongTouch from './longtouch'
import Zpm from './zpm'

const Directives = {
  install(vue) {
    new LongTouch(vue).install()
    new Zpm(vue).install()
  }
}

export default Directives
